import isSVGElement from './isSVGElement';
export default function isSVGSVGElement(node) {
  return isSVGElement(node) && 'createSVGPoint' in node;
}
//# sourceMappingURL=isSVGSVGElement.js.map